import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import {
  Badge,
  Breadcrumb,
  Button,
  Col,
  Input,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
  message,Tag
} from "antd";
import {
  CloseCircleFilled,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  SearchOutlined,
  PrinterOutlined,
  PrinterFilled,
  CheckCircleOutlined,
  ClockCircleOutlined, 


} from "@ant-design/icons";
import DatePicker from "react-modern-calendar-datepicker";
import moment from "moment-jalaali";
import { SetRoute } from "../scripts/action";
import { CheckPermission, PriceFormat, SearchFormat } from "../scripts/helpers";
import { Constants, Permissions } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import OrderForm from "../forms/Order";
import OrderView from "../views/Order";
import PrintView from "../views/Print";
const { TextArea } = Input;

class OrdersWaitiingPage extends Component {
  constructor() {
    super();

    this.state = {
      countries: [],
      data: [],
      filter: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      selected: {},

       supplierId: null,
      suppliers: [],
      supplierSearchLoading: false,

       // موارد جدید
      visibleStatusModal: false,
      statusProduct: null,
      productStatus: 0,
      rejectReason: "",
      statusSubmitting: false,
    };

    this.types = {
      orderType: {
        voip: Resources.withPhone,
        android: Resources.android,
        ios: Resources.ios,
        web: Resources.web,
      },
      postType: {
        delivery: Resources.storeCourier,
      },
      payType: {
        cardReader: Resources.pos,
        cash: Resources.cash,
        credit: Resources.credential,
        port: Resources.port,
      },
      status: {
        0: Resources.suspend,
        1: Resources.process,
        2: Resources.submit,
        3: Resources.delivered,
        4: Resources.returned,
      },
      statusColor: {
        0: "orange",
        1: "geekblue",
        2: "geekblue",
        3: "green",
        4: "red",
      },
      printView: false,
    };

    this.formRef = React.createRef();
  }

  fetch = (params = {}) => {
    const {
      filterEndDate,
      filterOrderType,
      filterStatus,
      filterPayStatus,
      filterPayType,
      filterSearch,
      filterStartDate,
      filterCountry,
    } = this.state;

    params.q = filterSearch;
    params.endDate = filterEndDate
      ? moment(
          `${filterEndDate.year}-${filterEndDate.month}-${filterEndDate.day}`,
          Constants.jDateFormat
        ).format(Constants.dateFormat)
      : null;
    params.startDate = filterStartDate
      ? moment(
          `${filterStartDate.year}-${filterStartDate.month}-${filterStartDate.day}`,
          Constants.jDateFormat
        ).format(Constants.dateFormat)
      : null;
    params.orderType = filterOrderType;
    params.payStatus = filterPayStatus;
    params.payType = filterPayType;
    params.status = filterStatus;
    params.country_id = filterCountry;
    this.setState({ loading: true });
    params.admin_status = 0;

    API.order
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };



  getCountries = (params = {}) => {

    API.country
      .list()
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            countries: result.data,
            
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };
  showEdit = (order = {}) => {
    this.setState({ orderEdit: true, selected: order });

    setTimeout(() => {
      this.formRef.current.handleDidMount(order);
    }, 0);
  };

  hideEdit = () => {
    this.setState({ orderEdit: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };

  showView = (order = {}) => {
    this.setState({ orderView: true, selected: order });
  };
  showPrint = (order = {}) => {
    this.setState({ printView: true, selected: order });
  };

  hideView = () => {
    this.setState({ orderView: false, printView: false });
  };

  handleFilter = (value, obj) => {
    const state = {};
    state[obj] = value;

    this.setState(state);

    setTimeout(() => {
      this.fetch({ page: 1 });
    }, 0);
  };

  handleDelete = (id) => {
    Modal.confirm({
      title: Resources.confirmDeleteOffer,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.order
          .delete(id)
          .then((result) => {
            message.success(result.message);

            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };
  handleExel = (id) => {
  
    API.order
      .getExcelOrder(id)
      .then((result) => {
        window.open(Constants.siteUrl + result.data)
        message.success(result.message);
      })
      .catch(() => {
        this.setState({ loading: false });
      });

};
  handleSubmit = (values) => {
    this.setState({ submitting: true });

    API.order
      .update(values, this.state.selected.id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideEdit();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTableChange = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  async componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    if (this.props.match.params.phone) {
      this.props.history.replace(`/orders`);
      this.handleFilter(this.props.match.params.phone, "filterSearch");
    } else {
      this.fetch({ page: 1 });
      await this.getCountries()
    }
    
  }
  getMahakRes = (val) => {

    if(val?.mahak_total_res){
      let baseItem = JSON.parse(val?.mahak_total_res)
      let item = baseItem?.data?.Objects?.Orders?.Results[0] ?? null;
      if(baseItem?.status){
        return <>
        <span>EntityId: {item?.EntityId} </span><br/>
        <span>EntityClientId: {item?.EntityClientId} </span><br/>
        <span>RowVersion: {item?.RowVersion} </span>
       </>
      }else{
        return  <span>{baseItem?.data?.Message} </span>
      }
    }

  }

    handleSupplierSearch = (value) => {
      const search = value.trim();
  
      if (!search) {
        this.setState({
          suppliers: [],
          supplierSearchLoading: false,
        });
  
        return;
      }
  
      this.setState({ supplierSearchLoading: true });
  
      API.user
        .search({
          q: SearchFormat(search),
        })
        .then((result) => {
  
          const users = Array.isArray(result.data)
            ? result.data.data || result.data
            : [];
  
          this.setState({
            suppliers: users,
            supplierSearchLoading: false,
          });
        })
        .catch(() => {
          this.setState({
            suppliers: [],
            supplierSearchLoading: false,
          });
        });
    };
  
    handleSupplierChange = (value) => {
      this.setState(
        {
          supplierId: value || undefined,
        },
        () => {
          this.fetch({
            page: 1,
          });
        }
      );
    };



      showStatusModal = (record) => {
        this.setState({
          visibleStatusModal: true,
          statusOrder: record,
          orderStatus: Number(record.admin_status),
          rejectReason: record.admin_reject_reason || "",
        });
      };
    
      hideStatusModal = () => {
        this.setState({
          visibleStatusModal: false,
          statusOrder: null,
          orderStatus: 0,
          rejectReason: "",
          statusSubmitting: false,
        });
      };
    
        handleStatusSubmit = () => {
          const {
            statusOrder,
            orderStatus,
            rejectReason,
          } = this.state;
      
          if (!statusOrder) {
            return;
          }
      
          // برای وضعیت رد شده، دلیل اجباری باشد
          if (Number(orderStatus) === -1 && !rejectReason.trim()) {
            message.error("لطفاً دلیل رد سفارش را وارد کنید.");
            return;
          }
      
          this.setState({ statusSubmitting: true });
      
          const payload = {
            status: Number(orderStatus),
            reject_reason:
              Number(orderStatus) === -1 ? rejectReason.trim() : null,
          };
      
          API.order
            .changeAdminStatus(statusOrder, payload)
            .then((result) => {
              message.success(result.message);
      
              this.hideStatusModal();
      
              this.fetch({
                page: this.state.pagination.current,
              });
            })
            .catch(() => {
              this.setState({ statusSubmitting: false });
            });
        };
  render() {
    const {
      data,
      filterEndDate,
      filterStartDate,
      loading,
      orderEdit,
      orderView,
      pagination,
      selected,
      submitting,
      printView,
      countries,
      supplierSearchLoading,
      supplierId,
      suppliers,
       // موارد جدید
      visibleStatusModal,
      statusOrder,
      orderStatus,
      rejectReason,
      statusSubmitting,
    } = this.state;
    const { permissions } = this.props;

    const columns = [
       {
        title: `${Resources.indentifier} `,
        dataIndex: "id",
        className: "col-center",
        width: "90px",
        // render: (val) => val?.country?.name ?? "",
      },
      {
        title: Resources.dateAndTime,
        dataIndex: "created_at",
        className: "col-ltr",
        width: "140px",
        render: (val) => moment(val).format(Constants.jDateTimeFormat),
      },
      {
        title: Resources.fullName,
        dataIndex: "user",
        render: (val) =>
          val
            ? val.name
              ? `${val.name} ${val.family}`
              : val.family
            : Resources.unknown,
      },
      {
        title: Resources.suppliers,
        className: "col-center",
         dataIndex: "product",
         render: (products) => {
            if (!Array.isArray(products)) return "-";

            return (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 6,
                  justifyContent: "center",
                }}
              >
                {[
                  ...new Set(
                    products
                      .map((product) => {
                        const supplier = product.supplier;

                        if (!supplier) return null;

                        const name = `${supplier.name || ""} ${supplier.family || ""}`.trim();
                        const code = supplier.supplier_code;

                        if (!name && !code) return null;

                        return JSON.stringify({
                          name,
                          code,
                        });
                      })
                      .filter(Boolean)
                      ),
                    ].map((item, index) => {
                      const supplier = JSON.parse(item);

                      return (
                        <Tag
                          key={index}
                          color="blue"
                          style={{
                            borderRadius: 8,
                            padding: "4px 8px",
                            fontSize: 13,
                          }}
                        >
                          {supplier.name}
                          {supplier.code && (
                            <span style={{ marginRight: 6, opacity: 0.7 }}>
                              ({supplier.code})
                            </span>
                          )}
                        </Tag>
                      );
                    })}
                  </div>
            );
          },
      },
      {
        title: Resources.mobile,
        dataIndex: "user",
        key: "mobile",
        className: "col-center",
        width: "110px",
        render: (val) => (val ? val.phone : "-"),
      },
     
      {
        title: `${Resources.country} `,
        dataIndex: "user",
        className: "col-center",
        width: "90px",
        render: (val) => val?.country?.name ?? "",
      },
      {
        title: `${Resources.type} ${Resources.order}`,
        dataIndex: "orderType",
        className: "col-center",
        width: "90px",
        render: (val) => this.types.orderType[val],
      },
      {
        title: `${Resources.amount} ${Resources.total} (${Resources.rial})`,
        dataIndex: "payable",
        className: "col-center",
        width: "120px",
        render: (val) => PriceFormat(val),
      },
      {
        title: `${Resources.mahak_res}`,
        dataIndex: "payment",
        className: "col-center",
        width: "200px",
        render: (val) => this.getMahakRes(val),
      },
      {
        title: `${Resources.type} ${Resources.payment}`,
        dataIndex: "paymentType",
        className: "col-center",
        width: "90px",
        render: (val) => this.types.payType[val],
      },
      {
        title: `${Resources.status} ${Resources.payment}`,
        dataIndex: "payment",
        width: "110px",
        render: (val) =>
          val && val.status ? (
            <Badge color="green" text={Resources.successful} />
          ) : (
            <Badge color="red" text={Resources.unsuccessful} />
          ), //<Badge color="red" text={Resources.unsuccessful} />
      },
      {
        title: Resources.carrier,
        dataIndex: "postType",
        className: "col-center",
        width: "120px",
        render: (val) => this.types.postType[val],
      },
      {
        title: `${Resources.firstName} ${Resources.delivery}`,
        dataIndex: "delivery",
        className: "col-center",
        render: (val) =>
          val && val.postman && val.postman.user
            ? val.postman.user.name
              ? `${val.postman.user.name} ${val.postman.user.family}`
              : val.postman.user.name
            : "-",
      },
      {
        title: `${Resources.firstName} ${Resources.registrar}`,
        dataIndex: "registrar",
        className: "col-center",
        render: (val) =>
          val ? (val.name ? `${val.name} ${val.family}` : val.family) : "-",
      },
      {
        title: Resources.status,
        dataIndex: "status",
        width: "80px",
        render: (val) => (
          <Badge
            color={this.types.statusColor[val]}
            text={this.types.status[val]}
          />
        ),
      },

           // --- ستون وضعیت تأیید ادمین ---
       {
              title: 'وضعیت ادمین',
              dataIndex: "admin_status",
              className: "col-center",
              width: "70px",
              render: (val, record) => {
                  const status = Number(val);
      
                  let title = "در انتظار تأیید";
                  let color = "#faad14";
      
                  if (status === 1) {
                    title = "تأیید شده";
                    color = "#52c41a";
                  } else if (status === -1) {
                    title = "رد شده";
                    color = "#ff4d4f";
                  }
      
                  return (
                    <Button
                      type="link"
                      size="small"
                      onClick={() => this.showStatusModal(record)}
                      // disabled={!permissions.action}
                      style={{
                        color,
                        padding: 0,
                      }}
                    >
                      {title}
                    </Button>
                  );
                },
      
      
            },
           
           
    ];

    // if (permissions.action || permissions.view) {
      columns.push({
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
              <Tooltip title={Resources.view}>
                <Button
                  type="link"
                  icon={<EyeOutlined />}
                  onClick={() => this.showView(record)}
                />
              </Tooltip>

              <Tooltip title={Resources.print}>
                <Button
                  type="link"
                  icon={<PrinterOutlined />}
                  onClick={() => this.showPrint(record)}
                />
              </Tooltip>
              {/* <Tooltip title={Resources.edit}>
                <Button
                  type="link"
                  icon={<EditOutlined />}
                  onClick={() => this.showEdit(record)}
                />
              </Tooltip>
            {permissions.action && (
              <Tooltip title={Resources.delete}>
                <Button
                  type="link"
                  icon={<DeleteOutlined />}
                  onClick={() => this.handleDelete(val)}
                />
              </Tooltip>
            )} */}

          <Tooltip title={Resources.excel}>
                <Button
                  type="link"
                  icon={<PrinterFilled />}
                  onClick={() => this.handleExel(val)}
                />
              </Tooltip>
          </Fragment>
        ),
      });
    // }

    const DatePickerInput = ({ ref }, date, placeholder) => (
      <Input
        value={date ? `${date.year}-${date.month}-${date.day}` : date}
        placeholder={placeholder}
        ref={ref}
        readOnly
      />
    );

    return (
      <Fragment>
        <OrderView
          data={selected}
          visible={orderView}
          onClose={this.hideView}
        />
        <PrintView
          data={selected}
          visible={printView}
          onClose={this.hideView}
        />
        <OrderForm
          ref={this.formRef}
          onCancel={this.hideEdit}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={orderEdit}
        />
        <Breadcrumb>
          <Breadcrumb.Item> {Resources.orders} </Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Row gutter={24} style={{ marginBottom: 16 }}>
            <Col xs={24} md={6}>
              <DatePicker
                locale="fa"
                value={filterStartDate}
                onChange={(value) =>
                  this.handleFilter(value, "filterStartDate")
                }
                renderInput={(ref) =>
                  DatePickerInput(ref, filterStartDate, Resources.fromDate)
                }
                shouldHighlightWeekends
              />
              {filterStartDate && (
                <CloseCircleFilled
                  className="ant-input-clear-icon ant-input-clear-icon-external"
                  onClick={() => this.handleFilter(null, "filterStartDate")}
                />
              )}
            </Col>
            <Col xs={24} md={6}>
              <DatePicker
                locale="fa"
                value={filterEndDate}
                onChange={(value) => this.handleFilter(value, "filterEndDate")}
                renderInput={(ref) =>
                  DatePickerInput(ref, filterEndDate, Resources.toDate)
                }
                shouldHighlightWeekends
              />
              {filterEndDate && (
                <CloseCircleFilled
                  className="ant-input-clear-icon ant-input-clear-icon-external"
                  onClick={() => this.handleFilter(null, "filterEndDate")}
                />
              )}
            </Col>
            <Col xs={24} md={{ span: 6, offset: 6 }}>
              <Tooltip title={Resources.searchSupplierHintOrder}>
                <Input
                  type="text"
                  prefix={<SearchOutlined />}
                  placeholder={Resources.search}
                  defaultValue={this.props.match.params.phone}
                  onChange={({ target: { value } }) =>
                    this.handleFilter(value, "filterSearch")
                  }
                  allowClear
                />
              </Tooltip>
            </Col>

           
          </Row>
          <Row gutter={24}>
            <Col xs={24} md={6}>
              <Select
                onChange={(value) =>
                  this.handleFilter(value, "filterOrderType")
                }
                placeholder={Resources.filterByOrderType}
                style={{ display: "block" }}
                allowClear
                showSearch
              >
                <Select.Option value="voip">
                  {this.types.orderType.voip}
                </Select.Option>
                <Select.Option value="android">
                  {this.types.orderType.android}
                </Select.Option>
                <Select.Option value="ios">
                  {this.types.orderType.ios}
                </Select.Option>
                <Select.Option value="web">
                  {this.types.orderType.web}
                </Select.Option>
              </Select>
            </Col>
            <Col xs={24} md={6}>
              <Select
                onChange={(value) => this.handleFilter(value, "filterPayType")}
                placeholder={Resources.filterByPayType}
                style={{ display: "block" }}
                allowClear
                showSearch
              >
                <Select.Option value="cardReader">
                  {this.types.payType.cardReader}
                </Select.Option>
                <Select.Option value="cash">
                  {this.types.payType.cash}
                </Select.Option>
                <Select.Option value="credit">
                  {this.types.payType.credit}
                </Select.Option>
                <Select.Option value="port">
                  {this.types.payType.port}
                </Select.Option>
              </Select>
            </Col>
            <Col xs={24} md={6}>
              <Select
                onChange={(value) =>
                  this.handleFilter(value, "filterPayStatus")
                }
                placeholder={Resources.filterByPayStatus}
                style={{ display: "block" }}
                allowClear
                showSearch
              >
                <Select.Option value="1">{Resources.successful}</Select.Option>
                <Select.Option value="0">
                  {Resources.unsuccessful}
                </Select.Option>
              </Select>
            </Col>
            <Col xs={24} md={6}>
              <Select
                onChange={(value) => this.handleFilter(value, "filterStatus")}
                placeholder={Resources.filterByStatus}
                style={{ display: "block" }}
                allowClear
                showSearch
              >
                <Select.Option value="0">{this.types.status[0]}</Select.Option>
                <Select.Option value="1">{this.types.status[1]}</Select.Option>
                <Select.Option value="2">{this.types.status[2]}</Select.Option>
                <Select.Option value="3">{this.types.status[3]}</Select.Option>
                <Select.Option value="4">{this.types.status[4]}</Select.Option>
              </Select>
            </Col>

                
            
          </Row>
          <Row gutter={24} style={{ marginTop: 16 }}> 
          <Col xs={24} md={6}>
              <Select
                onChange={(value) => this.handleFilter(value, "filterCountry")}
                placeholder={Resources.country}
                style={{ display: "block" }}
                allowClear
                showSearch
              >
              {countries && countries.length &&
                countries.map(item => 
                  <Select.Option value={item.id}>{item.name}</Select.Option>
                )
              }
                
              </Select>
            </Col>

            {/* <Col xs={24} md={5}>
                      <Select
                        showSearch
                        allowClear
                        placeholder="فیلتر بر اساس تأمین‌کننده"
                        style={{ display: "block", width: "100%" }}
                        filterOption={false}
                        onSearch={this.handleSupplierSearch}
                        onChange={this.handleSupplierChange}
                        loading={supplierSearchLoading}
                        value={supplierId}
                        notFoundContent={
                          supplierSearchLoading ? "در حال جستجو..." : "موردی یافت نشد"
                        }
                      >
                        {suppliers.map((supplier) => (
                          <Select.Option
                            key={supplier.id}
                            value={supplier.id}
                          >
                            {supplier.name} {supplier.family}
                          </Select.Option>
                        ))}
                      </Select>
                    </Col> */}
          </Row>
        </div>
        <div className="ant-content">
          <Table
            columns={columns}
            dataSource={data}
            loading={loading}
            onChange={this.handleTableChange}
            pagination={pagination}
            size="small"
            rowKey="id"
            scroll={{ x: 1400 }}
          />
          {!!pagination.total && (
            <PaginationInfo
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
            />
          )}
        </div>




         {/* manage product status */}
                          <Modal
                            title="تغییر وضعیت سفارش"
                            open={visibleStatusModal}
                            onCancel={this.hideStatusModal}
                            onOk={this.handleStatusSubmit}
                            okText="ذخیره"
                            cancelText="انصراف"
                            confirmLoading={statusSubmitting}
                            destroyOnClose
                          >
                            <div style={{ marginBottom: 16 }}>
                              <label
                                style={{
                                  display: "block",
                                  marginBottom: 8,
                                  fontWeight: 500,
                                }}
                              >
                                وضعیت سفارش
                              </label>
                
                              <Select
                                value={orderStatus}
                                onChange={(value) =>
                                  this.setState({
                                    orderStatus: Number(value),
                                  })
                                }
                                style={{ width: "100%" }}
                              >
                                <Select.Option value={0}>
                                  در انتظار تأیید
                                </Select.Option>
                
                                <Select.Option value={1}>
                                  تأیید شده
                                </Select.Option>
                
                                <Select.Option value={-1}>
                                  رد شده
                                </Select.Option>
                              </Select>
                            </div>
                
                            <div>
                              <label
                                style={{
                                  display: "block",
                                  marginBottom: 8,
                                  fontWeight: 500,
                                }}
                              >
                                دلیل رد
                              </label>
                
                              <TextArea
                                rows={4}
                                value={rejectReason}
                                onChange={(event) =>
                                  this.setState({
                                    rejectReason: event.target.value,
                                  })
                                }
                                placeholder="دلیل رد سفارش را وارد کنید"
                                disabled={Number(orderStatus) !== -1}
                              />
                            </div>
                
                            {statusOrder && (
                              <div style={{ marginTop: 12, color: "#888" }}>
                                سفارش: {statusOrder.id}
                              </div>
                            )}
                          </Modal>
                
                        {/* end of manage product status */}
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      permissions: {
        action: CheckPermission(state.app.user, Permissions.cart_option),
        view: CheckPermission(state.app.user, Permissions.cart_view),
      },
    };
  },
  (dispatch) => {
    return {
      onSetRoute: (data) => dispatch(SetRoute(data)),
    };
  }
)(OrdersWaitiingPage);
